import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getLevelList } from '@/service/mine'

export const useLevelStore = defineStore('level', () => {
  const levelList = ref<any[]>([])

  const getLevelListData = async () => {
    if (levelList.value.length > 0) return
    await loadLevelList()
  }

  const loadLevelList = async () => {
    const res = await getLevelList()
    if (res.code === 0) {
      levelList.value = res.data
    }
  }

  return {
    levelList,
    getLevelListData,
    loadLevelList,
  }
})
